import { useState } from "react";

import { Outlet } from "react-router-dom-v5-compat";
import * as z from "zod";

import { useBrand } from "./BrandContext";
import ErrorBoundary from "./ErrorBoundary";
import { VenueErrorPage } from "./ErrorPage";
import OnlineMenuMessage from "./OnlineMenuMessage";
import { SessionProvider } from "./Pages/Session/SessionContext";
import { useVenue } from "./VenueContext";
import { useRecordFeatureUsage } from "./queries";

const ten_minutes = 1000 * 60 * 10;
const SeenMenuMessagesSchema = z.record(z.string(), z.number());
const getHasSeenMessage = () =>
  SeenMenuMessagesSchema.parse(
    JSON.parse(localStorage.getItem("seenMenuMessages") || "{}"),
  );

const getHasSeenMessageInitialState = (currentMenuMessageTitle: string) => {
  const seenMenuMessages = getHasSeenMessage();
  return seenMenuMessages[currentMenuMessageTitle] > Date.now() - ten_minutes;
};
export const VenueLayout = () => {
  const brand = useBrand();
  const { venueBrand } = useVenue();

  const activeMenuMessage = venueBrand.activeMenuMessage;
  const [seenMenuMessage, setMenuMessage] = useState(
    activeMenuMessage
      ? getHasSeenMessageInitialState(activeMenuMessage.title)
      : true,
  );

  const recordFeatureUsage = useRecordFeatureUsage();
  const dismissMessage = () => {
    recordFeatureUsage.mutate({
      featureName: "Online / Menu Message",
      usageType: "engagement",
    });

    setMenuMessage(true);
    if (!activeMenuMessage) return;
    const seenMenuMessages = getHasSeenMessage();
    localStorage.setItem(
      "seenMenuMessages",
      JSON.stringify({
        ...seenMenuMessages,
        [activeMenuMessage.title]: Date.now(),
      }),
    );
  };
  return (
    <div
      style={brand.cssVariables}
      className="bg-venue-secondary text-venue-primary"
    >
      {!seenMenuMessage && (
        <div className="fixed inset-0 z-20 flex flex-col items-stretch justify-center">
          <div className="fixed inset-0 flex bg-venue-tertiary opacity-60" />
          <div className="z-10 flex items-stretch px-32">
            <OnlineMenuMessage onDismiss={dismissMessage} />
          </div>
        </div>
      )}
      <div className="mx-auto min-h-screen max-w-screen-xl px-16 md:px-32">
        <ErrorBoundary
          render={(message, resetError) => (
            <VenueErrorPage resetError={resetError} errorMessage={message} />
          )}
        >
          <SessionProvider>
            <Outlet />
          </SessionProvider>
        </ErrorBoundary>
      </div>
    </div>
  );
};
